module.exports = __webpack_public_path__ + "static/img/backpack7.75cbf63.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/backpack7.jpg
// module id = 174
// module chunks = 2